/**
 * Production Type Surface Chart Component
 * Displays audited surface by production type (convencional, eco, en conversión)
 */

import { Card, Empty } from 'antd';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import type { ProductionTypeData } from '../../services/api/productionDashboardService';

interface ProductionTypeSurfaceChartProps {
  data: ProductionTypeData[];
}

const COLORS = ['#52c41a', '#faad14', '#1890ff', '#d9d9d9'];

export const ProductionTypeSurfaceChart: React.FC<ProductionTypeSurfaceChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Card title="Superficie por Tipo de Producción">
        <Empty description="No hay datos disponibles" />
      </Card>
    );
  }

  // Filter out items with 0 surface
  const filteredData = data.filter(item => item.total_surface_ha > 0);

  if (filteredData.length === 0) {
    return (
      <Card title="Superficie por Tipo de Producción">
        <Empty description="No hay datos disponibles" />
      </Card>
    );
  }

  const chartData = filteredData.map(item => ({
    name: item.production_type_label,
    value: item.total_surface_ha,
  }));

  return (
    <Card title="Superficie por Tipo de Producción">
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} ${((percent || 0) * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((_entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value: number) => `${value.toFixed(2)} ha`} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};
